import cx from 'classnames';
import { useCallback } from 'react';

import CloseIcon from '@atlaskit/icon/core/cross';
import { RovoIcon } from '@atlaskit/logo';
import { Analytics } from '@trello/atlassian-analytics';
import { Button } from '@trello/nachos/button';
import { token } from '@trello/theme';

import * as styles from './RovoButton.module.less';

interface RovoButtonProps {
  isActive: boolean;
  onClick: () => void;
  source: 'cardDetailScreen' | 'rovoIsland';
  triggerRef?: (node: HTMLElement | null) => void;
  isCardBackButton?: boolean;
}

export const RovoButton = ({
  isActive,
  onClick,
  source,
  triggerRef,
  isCardBackButton = false,
}: RovoButtonProps) => {
  const handleClick = useCallback(() => {
    Analytics.sendClickedButtonEvent({
      buttonName: 'rovoChatButton',
      source,
      attributes: {
        action: isActive ? 'close' : 'open',
      },
    });

    onClick();
  }, [onClick, source, isActive]);

  return (
    <Button
      className={cx({
        [styles.rovoButton]: true,
        [styles.cardBackButton]: isCardBackButton,
      })}
      onClick={handleClick}
      ref={triggerRef}
      aria-label={isActive ? 'Close Rovo' : 'Open Rovo'} // TODO: i18n
    >
      {!isActive ? (
        <RovoIcon label="Rovo" appearance="inverse" size="small" /> // TODO: i18n
      ) : (
        <CloseIcon
          label="Close" // TODO: i18n
          color={token('color.icon.inverse', '#ffffff')}
        />
      )}
    </Button>
  );
};
